import type { RadarRole } from '../types/app';
import { loadAssessments, type Assessment } from './assessments';
import { studentsForAssessment, type LaunchStudent } from './launches';

export async function loadOmrAssessments(schoolId:string,role:RadarRole){
  const rows=await loadAssessments(schoolId,role);
  return rows.filter(a=>a.assessment_mode!=='WRITING' && Number(a.item_count)>0);
}

export async function loadOmrStudents(assessment:Assessment,schoolId:string,role:RadarRole){
  return studentsForAssessment(assessment,schoolId,role) as Promise<LaunchStudent[]>;
}
